import { Component, Vue, Prop } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import Highcharts, { PointOptionsObject } from 'highcharts';

@Component<PieChart>({})
export default class PieChart extends Vue {
  @Prop()
  protected data?: PointOptionsObject[];

  @Prop()
  protected colors?: string[];

  @Prop()
  protected title?: string;

  @Prop({ default: '{series.name}: <b>{point.percentage:.1f}%</b>' })
  protected pointFormat?: string;

  protected chartData: PointOptionsObject[] | undefined = [];

  protected chart: any;

  protected mounted(): void {
    this.chartData = cloneDeep(this.data);
    this.initialize();
  }

  protected initialize(): void {
    const chartContainer = (this.$refs.chart as HTMLElement);
    if (! chartContainer) {
      return;
    }

    if (this.colors) {
      Highcharts.setOptions({
        colors: this.colors,
      });
    }

    this.chart = Highcharts.chart({
      chart: {
        plotShadow: false,
        type: 'pie',
        renderTo: chartContainer,
      },
      legend: {
        itemStyle: { textOverflow: 'unset' },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: this.title,
      },
      tooltip: {
        pointFormat: this.pointFormat,
      },
      accessibility: {
        point: {
          valueSuffix: '%',
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            distance: - 75,
            useHTML: true,
            format: '<div style="width: 100%; text-align: center;"><b>{point.y} opdrachten</b><br>{point.percentage:.1f} %</div>',
            filter: {
              property: 'percentage',
              operator: '>',
              value: 4,
            },
          },
          showInLegend: true,
        },
      },
      series: [{
        type: 'pie',
        colorByPoint: true,
        data: this.chartData,
      }],
    });
  }
}
